import { CardTransaction } from '../models/CardTransaction';
import { CheckoutCommand } from '../models/CheckoutCommand';
import { OAuthApiClient } from './OAuthApiClient';

interface CardPaymentsSummary {
  url: string;
}

export class CardPaymentsApi {
  private publicOAuthApiClient: OAuthApiClient;
  constructor(oAuthApiClient: OAuthApiClient) {
    this.publicOAuthApiClient = oAuthApiClient;
  }

  public CreateCheckout = async (
    checkoutCommand: CheckoutCommand
  ): Promise<CardPaymentsSummary> => {
    switch (checkoutCommand.type) {
      case 'CardholderNotPresent':
        return this.publicOAuthApiClient.Post(
          'card-payments-api/checkout/cardholder-not-present',
          checkoutCommand
        );
      case 'CardholderPresent':
        return await this.publicOAuthApiClient.Post(
          `/card-payments-api/checkout/`,
          checkoutCommand
        );
    }
  };

  public GetCardTransaction = async (id: string): Promise<CardTransaction> => {
    return await this.publicOAuthApiClient.Get<CardTransaction>(
      `/card-payments-api/cardtransaction/${id}`
    );
  };

  public IsCompleted = async (identifier: string, amount: number): Promise<boolean> => {
    return await this.publicOAuthApiClient.Get<boolean>(
      `/card-payments-api/checkout/completed/invoice-payment-portal/${identifier}/${amount}`
    );
  };
}
